import { SyncOutlined } from '@ant-design/icons';

const Loading = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <SyncOutlined spin />
    </div>
  );
};

export default Loading;
